import {Component, ViewEncapsulation, Input, OnInit} from '@angular/core';
import { STOCK_LOGO_PLACEHOLDER } from '@toro/common/shared/resources/consts';
import { ICheckoutStock } from '../../../../../../interfaces/checkout.interface';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { calculateInvestment } from '../../../utils/investment-calculation';

@Component({
    selector: 'contracts-component',
    templateUrl: './contracts.component.html',
    styleUrls: ['contracts.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ContractsComponent {

    @Input('stock') public stock: ICheckoutStock;

    public logoPlaceholder = STOCK_LOGO_PLACEHOLDER;
    public typeMarketEnum  = OrderMarketTypeEnum;

    public get investments() {
        return calculateInvestment(this.stock);
    }

    public getFullPriceInvestment(value?: number) {
        if (value > 0) {
            if (!this.stock.isFractionary) {
                this.stock.buyAmount += value;
            } else if (this.stock.buyAmount + value < this.stock.mainLotDefault) {
                this.stock.buyAmount += value;
            }
        } else {
            if (this.stock.buyAmount + value >= this.stock.lotDefault) {
                this.stock.buyAmount += value;
            }
        }
    }
}
